(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('ColorDialogCtrl', colorDialogCtrl);

    function colorDialogCtrl(
        $scope,
        $mdDialog,
        $timeout,
        $location,
        LibrariesAPIService,
        colorMode,
        library,
        element,
        initialPosition,
        initialSort,
        blockUI
    ) {
        $scope.element = element;
        $scope.colorMode = colorMode.toLowerCase();
        $scope.colorOption = initialPosition;
        $scope.colorSort = initialSort;
        $scope.categoryId = $location.search().categoryId;
        $scope.currentColor = {
            HEX: '000000',
            alpha: 1
        };
        $scope.pickerCtrlMethods = {};
        $scope.errorMessage = '';

        // Set option if available. If element is not null we are in edit mode.
        if (element != null) {
            $scope.colorOption = element.position;
            $scope.colorSort = element.Sort;
            $scope.categoryId = element.LibraryCategoryId;
        }

        $scope.pickerColorChange = function (colors) {
            $scope.currentColor = colors;
            $timeout(function () {
                $scope.$apply();
            });
        };

        $scope.pickerReady = function (colors) {
            $scope.pickerColorChange(colors);

            // Set initial picker color if available
            if (element != null) {
                $scope.pickerCtrlMethods.setColor(element);
            }

            $scope.pickerCtrlMethods.openInContainer($('.color-library-dialog #pickerContainer').get(0));
        };

        $scope.toRgba = function (hex, alpha) {
            var converter = new Colors();
            var rgb = converter.convertColor(hex.replace('#', ''), 'HEX2RGB');
            return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + alpha + ')';
        };

        $scope.create = function () {
            // If element is not null we are in edit mode, update the element instead of creating it
            if (element === null) {
                blockUI.start('Saving color');
                LibrariesAPIService.addElement(
                    library.LibraryId,
                    $scope.colorOption,
                    {
                        hex: '#' + $scope.currentColor.HEX,
                        cmyk:
                            $scope.currentColor.cmyk.c +
                            ',' +
                            $scope.currentColor.cmyk.m +
                            ',' +
                            $scope.currentColor.cmyk.y +
                            ',' +
                            $scope.currentColor.cmyk.k,
                        alpha: $scope.currentColor.alpha,
                        LibraryCategoryId: $scope.categoryId
                    },
                    'color',
                    null,
                    $scope.colorSort
                )
                    .then(function () {
                        // New color added!
                        blockUI.stop();
                        $scope.pickerCtrlMethods.destroy();
                        $mdDialog.hide();
                    })
                    .catch(function (e) {
                        blockUI.stop();
                        if (e.status === 409) {
                            $scope.errorMessage = "There's already an element at position " + $scope.colorOption;
                        }
                    });
            } else {
                // Update element properties
                element.hex = '#' + $scope.currentColor.HEX;
                element.cmyk =
                    $scope.currentColor.cmyk.c +
                    ',' +
                    $scope.currentColor.cmyk.m +
                    ',' +
                    $scope.currentColor.cmyk.y +
                    ',' +
                    $scope.currentColor.cmyk.k;
                element.alpha = $scope.currentColor.alpha;
                element.LibraryCategoryId = $scope.categoryId;

                blockUI.start('Updating color');
                LibrariesAPIService.updateElement(library.LibraryId, element.ColorId, element, 'color')
                    .then(function () {
                        // Color updated!
                        blockUI.stop();
                        $scope.pickerCtrlMethods.destroy();
                        $mdDialog.hide();
                    })
                    .catch(function (e) {
                        blockUI.stop();
                        $scope.errorMessage = 'Error updating color!';
                    });
            }
        };

        $scope.cancel = function () {
            $scope.pickerCtrlMethods.destroy();
            $mdDialog.cancel();
        };
    }
})();
